module.exports = __webpack_public_path__ + "img/wrapbg1.dd4175b9.png";